<div *ngIf='screenWidth > 1230'>
  <div (window:orientationchange)="screenRotate($event)">
    <div class="bmw-lg-noisecatalog-home">
      <div class="flex-container row flex-align-center">
        <div class="bmw-lg-noisecatalog-home-title flex-65">
          Scope Pattern Library
        </div>
      </div>
      <div class="flex-container row flex-align-center">
        <div class="flex">
          <form form #formnoisecatalogfiltersearch="ngForm" style="width:93%"
            class="myForm input-group" name="findDocs">
            <div class="flex-container row flex-align-center">
              <div class="flex-100">
                <div class="input-group">
                  <label for="multiSelectSeries" style=" padding: .5em 0 .5em 0;flex: 2;">E Series</label>
                  <ng-multiselect-dropdown #multiSelectSeries id="multiSelectSeries" name="multiSelectSeries"
                    [placeholder]="'Select'" [data]="dropdownESeriesList" [(ngModel)]="seriesFilterList"
                    [settings]="dropdownSettingsSeries" [disabled]="false"
                    (onSelect)='addToNoiseSelection("series",$event)'
                    (onDeSelect)='removeFromNoiseSelection("series",$event)' style=" flex: 6; padding: .5em;">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>

            <div class="flex-container row flex-align-center-flex-end">
              <div class="flex-100">
                <div class="input-group">
                  <label for="multiSelectArea" style=" padding: .5em 0 .5em 0;flex: 2;">Signal Name</label>
                  <ng-multiselect-dropdown #multiSelectArea id="multiSelectArea" name="multiSelectArea"
                    [placeholder]="'Select'" [data]="dropdownAreaList" [(ngModel)]="areaFilterList"
                    [settings]="dropdownSettingsArea" (onSelect)='addToNoiseSelection("area",$event)'
                    (onDeSelect)='removeFromNoiseSelection("area",$event)' style=" flex: 6; padding: .5em;">
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>

            <div class="form-row">
              <button type="submit" (click)='populateFilteredScopePatternList()'>Search</button>
            </div>
          </form>
          <br />
        </div>
      </div>
      <div class="flex-container row flex-align-center">
        <div class="flex-65">
          <span *ngIf='newNoisecatalog?.length <=0 && searchClick===true'>
            <small style="font-size:16px;font-weight:normal;color: red">No results found for the given search
              criteria</small>
          </span>
        </div>
        <div class="bmw-lg-noisecatalog-home-title flex">
          <form #formnoisecatalogkeywordsearch="ngForm" style="width:70%;" class="input-group" name="findDocs">
            <input type="text" size=15 style="height:34px;font-size:16px;font-weight:normal;width: 100%"
              placeholder="Find Scope Pattern" name="techDoc" [(ngModel)]="search4noisecatalog">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : APP_SETTINGS.isMINI === 'true', 'bmw-button-style': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true'), 'rr-button-style' : (APP_SETTINGS.isRollsRoyce === 'true')}"
                class="btn btn-default" type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      
      <div class="divTable bmw-techTrainManualTable">
        <div class="divTableBody">
          <div class="col-lg-11 divTableRow" *ngFor='let noisecatalog of newNoisecatalog | searchFilter: "scopePatternDisplayNumber,scopePatternTitle": search4noisecatalog | loadMoreItems: moreItems'>
            <div>
              <a href="mount/scope_pattern/{{noisecatalog.splDocumentName}}" target="_blank">
                <div class="col-lg-3 divTableCell">{{ noisecatalog.scopePatternDisplayNumber }}</div>
                <div class="col-lg-6 divTableCell">{{ noisecatalog.scopePatternTitle }}</div>
                <div class="col-lg-3 divTableCell text-right">
                  <a class="bmw-align-icon-with-text" [ngClass]="{'mini-techTrainManualTable-icon-pdf' : APP_SETTINGS.isMINI === 'true','rr-techTrainManualTable-icon-pdf' : APP_SETTINGS.isRollsRoyce === 'true', 'bmw-techTrainManualTable-icon-pdf': (APP_SETTINGS.isBMW === 'true' || APP_SETTINGS.isMOTORRAD === 'true')}">
                    <i class="material-icons">
                      picture_as_pdf
                    </i>
                  </a>
                </div>
              </a>
            </div>            
          </div>
        </div>
      </div>

      <div class="col-lg-11 bmw-video-playback-showmore-button bmw-button-secondary pointer"
        (click)='moreItems = moreItems + 24' *ngIf='newNoisecatalog?.length > 24'>
        <label style="margin-top: 5px">Show More</label>
      </div>

    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="noisecatalogshareContent" role="dialog">
      <div class="modal-dialog bmw-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-noise-catalog-share-content [noisecatalogshareContent]='noisecatalogshareContentObject'>
            </app-noise-catalog-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
